function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M132 37h5v87H85V61H13V36h119z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M131.5 36.5h-118v24h72v63h51v-86h-5v-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M6 34.499h11L10.938 124H6z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M6.5 34.999V123.5h3.97l5.995-88.501H6.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M0 32h143v7H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M.5 32.5h142v6H.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M20 42h63v15H20z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M20.5 42.5h62v14h-62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M90 42h43v15H90z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M90.5 42.5h42v14h-42z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M90 60h43v25H90z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M90.5 60.5h42v24h-42z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M90 88h43v25H90z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M90.5 88.5h42v24h-42z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#D7D7D7",
  cx: 51.5,
  cy: 49.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51.5,
  cy: 49.5,
  r: 2,
  stroke: "#F4F4F4"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#D7D7D7",
  cx: 111.5,
  cy: 49.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111.5,
  cy: 49.5,
  r: 2,
  stroke: "#F4F4F4"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#D7D7D7",
  cx: 111.5,
  cy: 72.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111.5,
  cy: 72.5,
  r: 2,
  stroke: "#F4F4F4"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#D7D7D7",
  cx: 111.5,
  cy: 100.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111.5,
  cy: 100.5,
  r: 2,
  stroke: "#F4F4F4"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#D7D7D7",
  width: 43,
  height: 29,
  x: 29,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 28,
  x: 29.5,
  y: 0.5,
  stroke: "#F4F4F4",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#D7D7D7",
  width: 51,
  height: 5,
  x: 25,
  y: 28,
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 4,
  x: 25.5,
  y: 28.5,
  stroke: "#F4F4F4",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M32 3h37v23H32z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M32.5 3.5h36v22h-36z"
}));

function SvgRoomSceneryDesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: 124,
    viewBox: "0 0 143 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryDesk);
export default __webpack_public_path__ + "static/media/RoomSceneryDesk.136f10bc.svg";
export { ForwardRef as ReactComponent };